export type StoreArea = "us" | "uk" | "de" | "eu" | "ca" | "nl" | "fr" | "it" | "es"

export type ILocal = "en-US" | "en-GB" | "de" | "ca" | "de-EU" | "nl-NL" | 'fr-FR' | 'it-IT' | 'es-ES'
export type ICurrency = "USD" | "GBP" | "EUR" | "CAD"

export const localBizMap: Record<ILocal, StoreArea> = {
  "en-US": "us",
  "en-GB": "uk",
  de: "de",
  ca: "ca",
  "de-EU": "eu",
  "nl-NL": "nl",
  'fr-FR': 'fr',
  'it-IT': 'it',
  'es-ES': 'es',
}

export const LocalesMap: Record<string, string> = {
  'en-US': 'en-US',
  'en-GB': 'en-GB',
  de: 'de',
  ca: 'en-US', // ca 要用 en-US 才能显示正确的 CA$
  'de-EU': 'de-EU',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'it-IT': 'it-IT',
  'es-ES': 'es-ES',
}

export const localCurrencyMap: Record<ILocal, ICurrency> = {
  "en-US": "USD",
  "en-GB": "GBP",
  de: "EUR",
  ca: "CAD",
  "de-EU": "EUR",
  "nl-NL": "EUR",
  'fr-FR': 'EUR',
  'it-IT': 'EUR',
  'es-ES': 'EUR',
}

export function getStoreAreaFromLocale(locale?: string): StoreArea {
  if (locale) {
    const [, value] =
      Object.entries(localBizMap).find(([key, v]) => {
        return key.toLocaleLowerCase() === locale.toLocaleLowerCase()
      }) || []
    type NewType = StoreArea

    return (value || "us") as NewType
  }
  return "us"
}

export const transCountryToStoreArea = (countryCode: string): StoreArea => {
  const storeArea = COUNTRY_CODE_STORE_MAP[countryCode.toUpperCase()]
  return (storeArea || "us") as StoreArea
}

// EU店铺对应的国家码
export const EU_STORE_COUNTRY_CODES = [
  "AT", // 奥地利
  "BE", // 比利时
  "BG", // 保加利亚
  "HR", // 克罗地亚
  "CZ", // 捷克
  "DK", // 丹麦
  "EE", // 爱沙尼亚
  "FI", // 芬兰
  "FR", // 法国
  "GR", // 希腊
  "HU", // 匈牙利
  "IT", // "意大利109/110 个省）"
  "LV", // 拉脱维亚
  "LT", // 立陶宛
  "LU", // 卢森堡
  "MT", // 马耳他
  "PL", // 波兰
  "PT", // 葡萄牙
  "RO", // 罗马尼亚
  "SK", // 斯洛伐克
  "SI", // 斯洛文尼亚
  "ES", // 西班牙（49/52 个省）
  "SE", // 瑞典
]
export const UK_STORE_COUNTRY_CODES = ["UK", "GB"]
export const DE_STORE_COUNTRY_CODES = ["DE"]
export const US_STORE_COUNTRY_CODES = ["US"]
export const CA_STORE_COUNTRY_CODES = ["CA"]
export const NL_STORE_COUNTRY_CODES = ["NL"]
export const FR_STORE_COUNTRY_CODES = ['FR']
export const IT_STORE_COUNTRY_CODES = ['IT']
export const ES_STORE_COUNTRY_CODES = ['ES']

export const STORE_COUNTRY_CODES_MAP: Record<StoreArea, string[]> = {
  us: US_STORE_COUNTRY_CODES,
  uk: UK_STORE_COUNTRY_CODES,
  de: DE_STORE_COUNTRY_CODES,
  ca: CA_STORE_COUNTRY_CODES,
  eu: EU_STORE_COUNTRY_CODES,
  nl: NL_STORE_COUNTRY_CODES,
  fr: FR_STORE_COUNTRY_CODES,
  it: IT_STORE_COUNTRY_CODES,
  es: ES_STORE_COUNTRY_CODES,
}

export const COUNTRY_CODE_STORE_MAP: Record<string, StoreArea> = {
  ...EU_STORE_COUNTRY_CODES.reduce((o, code) => {
    o[code] = "eu"
    return o
  }, {} as Record<string, StoreArea>),
  ...UK_STORE_COUNTRY_CODES.reduce((o, code) => {
    o[code] = "uk"
    return o
  }, {} as Record<string, StoreArea>),
  ...DE_STORE_COUNTRY_CODES.reduce((o, code) => {
    o[code] = "de"
    return o
  }, {} as Record<string, StoreArea>),
  ...US_STORE_COUNTRY_CODES.reduce((o, code) => {
    o[code] = "us"
    return o
  }, {} as Record<string, StoreArea>),
  ...CA_STORE_COUNTRY_CODES.reduce((o, code) => {
    o[code] = "ca"
    return o
  }, {} as Record<string, StoreArea>),
  // start_ai_generated
  ...NL_STORE_COUNTRY_CODES.reduce((o, code) => {
    o[code] = "nl"
    return o
  }, {} as Record<string, StoreArea>),
  ...FR_STORE_COUNTRY_CODES.reduce((o, code) => {
    o[code] = 'fr'
    return o
  }, {} as Record<string, StoreArea>),
  ...IT_STORE_COUNTRY_CODES.reduce((o, code) => {
    o[code] = 'it'
    return o
  }, {} as Record<string, StoreArea>),
  ...ES_STORE_COUNTRY_CODES.reduce((o, code) => {
    o[code] = 'es'
    return o
  }, {} as Record<string, StoreArea>),
}

export const EU_STORE_CODES = ['uk', 'de', 'nl', 'eu', 'fr', 'it', 'es']
